module.exports = __webpack_public_path__ + "img/celery2.757946f6.svg";